import * as tslib_1 from "tslib";
import { formatterComponentType, getMobileComponentByControlType } from '../../../../../form/utils';
import { Component, Prop, Vue } from "vue-property-decorator";
import { FormControlType } from "../../typings";
import InputDateRange from "./input-date-range.vue";
import InputNumberRange from "./input-number-range.vue";
import InputTimeRange from "./input-time-range.vue";
let BaseControlAdapter = class BaseControlAdapter extends Vue {
    render(h) {
        const control = this.control;
        const type = control.type;
        if (this.control.type === FormControlType.Label) {
            return h("label", [control.controller.value]);
        }
        const opts = {
            props: Object.assign({
                control: control
            }, this.$attrs)
        };
        let mobileComponent = getMobileComponentByControlType(control.type);
        if (mobileComponent && mobileComponent.mobile) {
            const components = this.$options.components;
            if (components) {
                // console.log('formatterComponentType===>', control)
                return h(formatterComponentType(mobileComponent.key), { props: {
                        control
                    } });
            }
        }
        switch (control.type) {
            // case FormControlType.Text:
            // case FormControlType.Textarea:
            //   return h("input-text", opts);
            // case FormControlType.Date:
            //   return h("input-date", opts);
            case FormControlType.DateRange:
                return h("input-date-range", opts);
            case FormControlType.TimeRange:
                return h("input-time-range", opts);
            // case FormControlType.Number:
            //   return h("input-number", opts);
            case FormControlType.NumberRange:
                return h("input-number-range", opts);
            // case FormControlType.Location:
            //   return h("input-location", opts);
            // case FormControlType.Logic:
            //   return h("input-logic", opts);
            // case FormControlType.Radio:
            // case FormControlType.Checkbox:
            //   return h("checkbox-group", opts);
            // case FormControlType.Dropdown:
            //   return h("dropdown", opts);
            // case FormControlType.Attachment:
            // case FormControlType.Image:
            //   return h("upload", opts);
            // case FormControlType.Signature:
            //   return h("input-signsture", opts)
            // case FormControlType.Address:
            //   return h("input-address", opts);
            // case FormControlType.StaffSelector:
            // case FormControlType.StaffMultiSelector:
            // case FormControlType.DepartmentSelector:
            // case FormControlType.DepartmentMultiSelector:
            //   return h("form-staff-selector", opts);
            // case FormControlType.Address:
            //   return h("address", opts);
            // case FormControlType.RelevanceForm:
            //   return h("relevance-form", opts);
            // case FormControlType.ReverseRelevance:
            //   return h("reverse-relevance", opts);
            case FormControlType.Html:
                return this.createHtml(h, control);
        }
    }
    createHtml(h, hc) {
        const attrs = {};
        hc.attrs.forEach(a => (attrs[a.name] = a.value));
        const domProps = {
            innerHTML: hc.innerHTML
        };
        return h(hc.tagName, {
            attrs,
            domProps
        });
    }
    created() {
        let mobileInfo = getMobileComponentByControlType(this.control.type);
        if (mobileInfo && mobileInfo.mobile) {
            const components = this.$options.components;
            if (components) {
                components[formatterComponentType(mobileInfo.key)] = mobileInfo.mobile;
            }
        }
    }
};
tslib_1.__decorate([
    Prop()
], BaseControlAdapter.prototype, "control", void 0);
BaseControlAdapter = tslib_1.__decorate([
    Component({
        name: "base-control-adapter",
        components: {
            // Upload,
            // CheckboxGroup,
            // Dropdown,
            // InputText,
            // InputNumber,
            // InputDate,
            // InputLogic,
            // InputLocation,
            // ApproveOpinion,
            InputDateRange,
            InputNumberRange,
            InputTimeRange
            // RelevanceForm,
            // ReverseRelevance,
            // InputAddress,
            // InputSignsture
        }
    })
], BaseControlAdapter);
export default BaseControlAdapter;
